(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-muncle"]) return;
  try {
    
(() => {
  function initializeProducts() {
    document.querySelectorAll('[data-mm-gallery-version="2"]:not([data-mm-ready])').forEach((gallery) => {
      const featured = gallery.querySelector('[data-mm-gallery-image]');
      const opener = gallery.querySelector('[data-mm-gallery-open]');
      const dialog = gallery.querySelector('[data-mm-gallery-dialog]');
      const enlarged = gallery.querySelector('[data-mm-gallery-dialog-image]');
      if (!featured || !opener || !dialog || !enlarged) return;
      gallery.dataset.mmReady = 'true';
      let fullSource = enlarged.dataset.mmFullSrc;
      const thumbs = [...gallery.querySelectorAll('[data-mm-gallery-thumb]')];
      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-mm-gallery-thumb]');
        if (!thumb) return;
        featured.srcset = thumb.dataset.mmImageSrcset;
        featured.src = thumb.dataset.mmImageSrc;
        featured.alt = thumb.dataset.mmImageAlt || '';
        opener.setAttribute('aria-label', featured.alt);
        fullSource = thumb.dataset.mmImageFull;
        thumbs.forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          if (item === thumb) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      });
      gallery.addEventListener('mm:variant-image',event=>{
        const data=event.detail;if(!data.mmImageSrc)return;
        featured.removeAttribute('srcset');featured.src=data.mmImageSrc;featured.alt=data.mmImageAlt || '';
        opener.setAttribute('aria-label', featured.alt);
        fullSource=data.mmImageFull;
        thumbs.forEach(thumb=>{thumb.classList.remove('is-active');thumb.removeAttribute('aria-current');});
      });
      opener.addEventListener('click', () => {
        enlarged.src = fullSource;
        enlarged.alt = featured.alt;
        dialog.showModal();
      });
      gallery.querySelector('[data-mm-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
    document.querySelectorAll('[data-mm-product-root]:not([data-mm-product-ready])').forEach((root) => {
      root.dataset.mmProductReady = 'true';
      const variants = root.querySelector('[data-mm-variant-select]');
      const price = root.querySelector('[data-mm-product-price]');
      if (variants && price) variants.addEventListener('change', () => {
        const option = variants.selectedOptions[0];
        price.textContent = option.dataset.mmPrice;
        root.querySelectorAll('[data-mm-sku-row] [data-mm-sku]').forEach(el=>el.textContent=option.dataset.mmSku || '');
        root.querySelectorAll('[data-mm-sku-row]').forEach(el=>el.hidden=!option.dataset.mmSku);
        const qty=root.querySelector('input[name="quantity"]');
        qty.min=option.dataset.mmMin || '1';qty.step=option.dataset.mmStep || '1';qty.value=qty.min;
        if(option.dataset.mmMax)qty.max=option.dataset.mmMax;else qty.removeAttribute('max');
        const thumb = root.querySelector('[data-mm-gallery-thumb][data-mm-image-id="'+option.dataset.mmImageId+'"]');
        if(thumb)thumb.click();
        else root.querySelector('[data-mm-gallery]')?.dispatchEvent(new CustomEvent('mm:variant-image',{detail:option.dataset}));
        const available=option.dataset.mmAvailable==='true';
        const submit=root.querySelector('.mm-product-form button[type="submit"]');if(submit)submit.disabled=!available;
        const availability=root.querySelector('[data-mm-availability]');if(availability){availability.textContent=available?root.dataset.mmAvailableLabel:root.dataset.mmSoldLabel;availability.classList.toggle('mm-product-availability--sold',!available);}
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(history.state,'',url);
        root.querySelector('[data-mm-sticky-price]').textContent=price.textContent;
      });
      const buyBar=root.querySelector('[data-mm-sticky-buy]');
      const form=root.querySelector('.mm-product-form');
      if(buyBar && form && 'IntersectionObserver' in window){
        new IntersectionObserver(entries=>{const e=entries[0];buyBar.hidden=e.isIntersecting || e.boundingClientRect.top>0;},{threshold:0}).observe(form);
        buyBar.querySelector('[data-mm-return-to-buy]').addEventListener('click',()=>{ form.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); form.querySelector('select, input[type="number"], button[type="submit"]')?.focus({preventScroll:true}); });
      }
      const badge = root.querySelector('[data-judge-badge-root]');
      if (!badge) return;
      const updateBadge = () => {
        const preview = badge.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
        const count = Number.parseInt(preview?.getAttribute('data-number-of-reviews') || '', 10);
        const text = preview?.textContent.trim().toLowerCase() || '';
        const visible = Number.isFinite(count) ? count > 0 : Boolean(text) && !/no reviews|be the first to write a review|0 reviews?/.test(text);
        if (badge.classList.contains('is-visible') !== visible) badge.classList.toggle('is-visible', visible);
      };
      updateBadge();
      new MutationObserver(updateBadge).observe(badge, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews']});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeProducts, {once:true});
  else initializeProducts();
  document.addEventListener('shopify:section:load', initializeProducts);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-brands-hub"]) return;
  try {
    
if (!customElements.get('mm-brand-directory')) customElements.define('mm-brand-directory', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const input = this.querySelector('[data-brand-search]');
    const status = this.querySelector('[data-brand-status]');
    const empty = this.querySelector('[data-brand-empty]');
    const productSearch = this.querySelector('[data-brand-product-search]');
    const buttons = [...this.querySelectorAll('[data-brand-letter]')];
    const entries = [...this.querySelectorAll('[data-mm-directory-item]')];
    if (!input || !status || !empty || !entries.length) return;
    this.ready = true;
    let letter = '';
    const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[-_]+/g,' ').toLocaleLowerCase();
    const records = entries.map(node => ({
      node,
      text: normalize(node.textContent + ' ' + (node.dataset.mmDirectorySearchText || '')),
      label: normalize(node.textContent).trim()
    }));
    const baseSearchUrl = productSearch && productSearch.getAttribute('href');
    const update = () => {
      const words = normalize(input.value).trim().split(/\s+/).filter(Boolean);
      let count = 0;
      records.forEach(record => {
        const starts = !letter || record.label.charAt(0).toUpperCase() === letter;
        const wordsMatch = words.every(word => record.text.includes(word));
        record.node.hidden = !(starts && wordsMatch);
        if (!record.node.hidden) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', button.dataset.brandLetter === letter ? 'true' : 'false'));
      status.textContent = (this.dataset.matchLabel || '__COUNT__').replace('__COUNT__', count);
      empty.hidden = count > 0;
      if (productSearch && baseSearchUrl) {
        const destination = new URL(baseSearchUrl, window.location.origin);
        const query = input.value.trim();
        if (query) destination.searchParams.set('q', query);
        else destination.searchParams.delete('q');
        destination.searchParams.set('type','product');
        productSearch.setAttribute('href', destination.pathname + destination.search);
      }
    };
    input.addEventListener('input', update);
    input.addEventListener('search', update);
    buttons.forEach(button => button.addEventListener('click', () => {
      const next = button.dataset.brandLetter || '';
      letter = letter === next ? '' : next;
      update();
    }));
    update();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collector-report"]) return;
  try {
    
(() => {
  'use strict';
  const STORAGE_KEY = 'mm_collector_collection_v2';
  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const numberFrom = (value) => {
    const match = clean(value).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : null;
  };
  const money = (value) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value) || 0);
  const readCollection = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch (_) {
      return {};
    }
  };

  const drawQr = (canvas, value) => {
    if (!canvas || !value || typeof TextEncoder === 'undefined') return false;
    const payload = Array.from(new TextEncoder().encode(value));
    const specs = {
      1: { data: 19, blocks: [[1, 26, 19]], align: [] },
      2: { data: 34, blocks: [[1, 44, 34]], align: [6, 18] },
      3: { data: 55, blocks: [[1, 70, 55]], align: [6, 22] },
      4: { data: 80, blocks: [[1, 100, 80]], align: [6, 26] },
      5: { data: 108, blocks: [[1, 134, 108]], align: [6, 30] },
      6: { data: 136, blocks: [[2, 86, 68]], align: [6, 34] }
    };
    const version = [1, 2, 3, 4, 5, 6].find((item) => payload.length <= specs[item].data - 2);
    if (!version) return false;
    const spec = specs[version];
    const bits = [];
    const push = (valueToPush, length) => { for (let i = length - 1; i >= 0; i -= 1) bits.push((valueToPush >>> i) & 1); };
    push(4, 4);
    push(payload.length, 8);
    payload.forEach((byte) => push(byte, 8));
    const maxBits = spec.data * 8;
    for (let i = 0; i < 4 && bits.length < maxBits; i += 1) bits.push(0);
    while (bits.length % 8) bits.push(0);
    const data = [];
    for (let i = 0; i < bits.length; i += 8) data.push(bits.slice(i, i + 8).reduce((sum, bit) => (sum << 1) | bit, 0));
    for (let pad = 0; data.length < spec.data; pad += 1) data.push(pad % 2 ? 0x11 : 0xec);

    const exp = new Array(512).fill(0);
    const log = new Array(256).fill(0);
    let x = 1;
    for (let i = 0; i < 255; i += 1) {
      exp[i] = x;
      log[x] = i;
      x <<= 1;
      if (x & 0x100) x ^= 0x11d;
    }
    for (let i = 255; i < 512; i += 1) exp[i] = exp[i - 255];
    const multiply = (a, b) => (!a || !b ? 0 : exp[log[a] + log[b]]);
    const errorCode = (block, count) => {
      let generator = [1];
      for (let i = 0; i < count; i += 1) {
        const next = new Array(generator.length + 1).fill(0);
        generator.forEach((coefficient, index) => {
          next[index] ^= coefficient;
          next[index + 1] ^= multiply(coefficient, exp[i]);
        });
        generator = next;
      }
      const remainder = block.concat(new Array(count).fill(0));
      for (let i = 0; i < block.length; i += 1) {
        const coefficient = remainder[i];
        if (!coefficient) continue;
        generator.forEach((item, index) => { remainder[i + index] ^= multiply(item, coefficient); });
      }
      return remainder.slice(-count);
    };
    const dataBlocks = [];
    const errorBlocks = [];
    let offset = 0;
    spec.blocks.forEach(([count, totalCount, dataCount]) => {
      for (let i = 0; i < count; i += 1) {
        const block = data.slice(offset, offset + dataCount);
        offset += dataCount;
        dataBlocks.push(block);
        errorBlocks.push(errorCode(block, totalCount - dataCount));
      }
    });
    const codewords = [];
    const maxData = Math.max(...dataBlocks.map((block) => block.length));
    const maxError = Math.max(...errorBlocks.map((block) => block.length));
    for (let i = 0; i < maxData; i += 1) dataBlocks.forEach((block) => { if (i < block.length) codewords.push(block[i]); });
    for (let i = 0; i < maxError; i += 1) errorBlocks.forEach((block) => { if (i < block.length) codewords.push(block[i]); });

    const size = version * 4 + 17;
    const modules = Array.from({ length: size }, () => new Array(size).fill(null));
    const finder = (left, top) => {
      for (let row = -1; row <= 7; row += 1) for (let col = -1; col <= 7; col += 1) {
        const y = top + row;
        const xPos = left + col;
        if (y < 0 || y >= size || xPos < 0 || xPos >= size) continue;
        modules[y][xPos] = row >= 0 && row <= 6 && col >= 0 && col <= 6 && (row === 0 || row === 6 || col === 0 || col === 6 || (row >= 2 && row <= 4 && col >= 2 && col <= 4));
      }
    };
    finder(0, 0);
    finder(size - 7, 0);
    finder(0, size - 7);
    spec.align.forEach((cy) => spec.align.forEach((cx) => {
      if (modules[cy][cx] !== null) return;
      for (let row = -2; row <= 2; row += 1) for (let col = -2; col <= 2; col += 1) modules[cy + row][cx + col] = Math.max(Math.abs(row), Math.abs(col)) !== 1;
    }));
    for (let i = 8; i < size - 8; i += 1) {
      if (modules[6][i] === null) modules[6][i] = i % 2 === 0;
      if (modules[i][6] === null) modules[i][6] = i % 2 === 0;
    }
    const bch = (input) => {
      let valueToDivide = input << 10;
      const degree = (value) => { let result = 0; for (let current = value; current; current >>>= 1) result += 1; return result; };
      while (degree(valueToDivide) - degree(0x537) >= 0) valueToDivide ^= 0x537 << (degree(valueToDivide) - degree(0x537));
      return ((input << 10) | valueToDivide) ^ 0x5412;
    };
    const format = bch(8);
    for (let i = 0; i < 15; i += 1) {
      const dark = ((format >> i) & 1) === 1;
      if (i < 6) modules[i][8] = dark;
      else if (i < 8) modules[i + 1][8] = dark;
      else modules[size - 15 + i][8] = dark;
      if (i < 8) modules[8][size - i - 1] = dark;
      else if (i === 8) modules[8][7] = dark;
      else modules[8][15 - i - 1] = dark;
    }
    modules[size - 8][8] = true;
    let row = size - 1;
    let direction = -1;
    let byteIndex = 0;
    let bitIndex = 7;
    for (let col = size - 1; col > 0; col -= 2) {
      if (col === 6) col -= 1;
      while (true) {
        for (let pass = 0; pass < 2; pass += 1) {
          const targetCol = col - pass;
          if (modules[row][targetCol] !== null) continue;
          let dark = byteIndex < codewords.length ? ((codewords[byteIndex] >>> bitIndex) & 1) === 1 : false;
          if ((row + targetCol) % 2 === 0) dark = !dark;
          modules[row][targetCol] = dark;
          bitIndex -= 1;
          if (bitIndex < 0) { byteIndex += 1; bitIndex = 7; }
        }
        row += direction;
        if (row < 0 || row >= size) { row -= direction; direction = -direction; break; }
      }
    }
    const quiet = 4;
    const scale = 4;
    canvas.width = (size + quiet * 2) * scale;
    canvas.height = canvas.width;
    const context = canvas.getContext('2d');
    context.imageSmoothingEnabled = false;
    context.fillStyle = '#fff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#050505';
    modules.forEach((moduleRow, yPos) => moduleRow.forEach((isDark, xPos) => {
      if (isDark) context.fillRect((xPos + quiet) * scale, (yPos + quiet) * scale, scale, scale);
    }));
    return true;
  };

  const initializeReport = (root) => {
    const report = root.querySelector('[data-mmve-report]');
    const sourceElement = root.querySelector('.mmcr-static-content');
    const source = sourceElement?.content || sourceElement;
    if (!report || !source || report.dataset.mmveReady === 'true') return;
    report.dataset.mmveReady = 'true';
    const set = (key, value) => {
      if (value === undefined || value === null || value === '') return;
      report.querySelectorAll(`[data-mmve="${key}"]`).forEach((node) => { node.textContent = value; });
    };
    const facts = {};
    source.querySelectorAll('.mm-fact, dl > div').forEach((row) => {
      const key = clean(row.querySelector('dt')?.textContent).toLowerCase().replace(/:$/, '');
      const value = clean(row.querySelector('dd')?.textContent);
      if (key && value && !facts[key]) facts[key] = value;
    });
    source.querySelectorAll('tr').forEach((row) => {
      const label = row.querySelector('th[scope="row"]');
      const value = row.querySelector('td');
      const key = clean(label?.textContent).toLowerCase().replace(/:$/, '');
      if (key && value && !facts[key]) facts[key] = clean(value.textContent);
    });
    const fact = (...keys) => keys.map((key) => facts[key]).find(Boolean) || '';
    const shortFact = (maximum, ...keys) => {
      const value = fact(...keys);
      return clean(value).length <= maximum ? value : '';
    };
    const stat = (label) => {
      const row = Array.from(source.querySelectorAll('.mm-score-stat, .mm7-stat')).find((node) => clean(node.querySelector('span')?.textContent).toLowerCase() === label.toLowerCase());
      const value = clean(row?.querySelector('strong')?.textContent) || fact(label.toLowerCase());
      return value && value.includes('/') ? value : value ? `${value}/100` : '';
    };
    let structured = null;
    source.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      if (structured) return;
      try {
        const parsed = JSON.parse(script.textContent);
        if (parsed && parsed.image) structured = parsed;
      } catch (_) {}
    });
    let image = report.querySelector('[data-mmve-image]')?.getAttribute('src') || structured?.image;
    if (Array.isArray(image)) image = image[0];
    if (image && typeof image === 'object') image = image.url || image.contentUrl;
    if (typeof image === 'string') {
      try {
        const imageHost = new URL(image, location.origin).hostname.toLowerCase();
        const isShopifyHosted = imageHost === 'cdn.shopify.com' || imageHost === location.hostname || imageHost.endsWith('.myshopify.com');
        if (!isShopifyHosted) image = '';
      } catch (_) {
        image = '';
      }
    } else {
      image = '';
    }
    if (!image) {
      const sourceImage = Array.from(source.querySelectorAll('img')).find((node) => {
        const src = node.currentSrc || node.getAttribute('src') || '';
        return /^https:\/\/cdn\.shopify\.com\//i.test(src);
      });
      image = sourceImage ? (sourceImage.currentSrc || sourceImage.getAttribute('src') || '') : '';
    }
    const photo = report.querySelector('[data-mmve-image]');
    if (photo && typeof image === 'string' && image) {
      const imageFallback = () => {
        photo.removeAttribute('src');
        photo.alt = '';
        photo.closest('.mmve-photo')?.classList.add('is-image-pending');
      };
      photo.addEventListener('error', imageFallback, { once: true });
      photo.alt = clean(structured?.name || report.dataset.mmveTitle || document.title);
      photo.src = image;
      window.setTimeout(() => { if (photo.complete && !photo.naturalWidth) imageFallback(); }, 1800);
    } else if (photo) {
      photo.closest('.mmve-photo')?.classList.add('is-image-pending');
    }
    const brand = typeof structured?.brand === 'string' ? structured.brand : structured?.brand?.name;
    set('brand', shortFact(32, 'brand', 'manufacturer') || brand || 'Hot Wheels');
    set('casting', shortFact(70, 'casting', 'model', 'casting / model') || clean(structured?.name).replace(/^\d{4}\s+Hot Wheels\s+/i, '').slice(0, 70) || report.dataset.mmveTitle);
    set('series', shortFact(46, 'series', 'mini collection') || '—');
    set('year', shortFact(12, 'year', 'release year') || '—');
    set('color', shortFact(34, 'body color', 'color') || '—');
    set('wheels', shortFact(40, 'wheels', 'wheel type') || '—');
    set('base', shortFact(34, 'base', 'base material') || 'Not documented');
    set('country', shortFact(28, 'country', 'country of origin', 'made in') || 'Not documented');
    set('scale', shortFact(12, 'scale') || 'Not documented');
    set('special', shortFact(42, 'release class', 'special', 'rarity') || '—');
    set('notes', shortFact(58, 'notes', 'release class') || 'Documented release');
    const completeness = stat('Record completeness') || '0/100';
    const evidence = stat('Evidence confidence') || '0/100';
    const media = stat('Media verification') || '0/100';
    const market = stat('Market evidence') || '0/100';
    const scoreText = clean(source.querySelector('.mm-score__value strong, .mm-score-ring strong')?.textContent) || '0';
    const statedScore = Math.max(0, Math.min(100, Number.parseInt(scoreText, 10) || 0));
    const componentScores = [completeness, evidence, media, market].map((value) => Number.parseInt(value, 10)).filter(Number.isFinite);
    const score = statedScore || (componentScores.length ? Math.round(componentScores.reduce((sum, value) => sum + value, 0) / componentScores.length) : 0);
    set('score', score);
    set('score-label', score >= 80 ? 'Excellent Example' : score >= 60 ? 'Strong Record' : score >= 40 ? 'Developing Record' : 'Limited Evidence');
    const marketNumber = Math.max(0, Math.min(100, Number.parseInt(market, 10) || 0));
    set('market-score', market);
    set('demand-score', market);
    set('formula-record', completeness);
    set('formula-evidence', evidence);
    set('formula-media', media);
    const confidence = Math.max(0, Math.min(100, Number.parseInt(evidence, 10) || 0));
    set('confidence', `${confidence}%`);
    report.querySelector('.mmve-gauge i')?.style.setProperty('--mm-confidence-angle', `${confidence * 1.8}deg`);
    set('confidence-label', confidence >= 85 ? 'Very High' : confidence >= 70 ? 'High' : confidence >= 50 ? 'Moderate' : 'Limited');
    const grade = confidence >= 90 ? 'A' : confidence >= 75 ? 'B' : confidence >= 55 ? 'C' : 'D';
    set('grade', grade);
    set('grade-label', grade === 'A' ? 'Excellent' : grade === 'B' ? 'Good' : grade === 'C' ? 'Developing' : 'Limited');
    set('grade-note', marketNumber === 0 ? 'Confirmed sales are not available yet' : 'Based on confirmed sales');

    const prices = {};
    source.querySelectorAll('.mm-value-point, .mm-static-values > div').forEach((row) => {
      const label = clean(row.querySelector('span, dt')?.textContent).toLowerCase();
      const value = clean(row.querySelector('strong, dd')?.textContent);
      if (/^(low|typical|high)$/.test(label) && value && !/pending/i.test(value)) prices[label] = value;
    });
    const targetBody = report.querySelector('.mmve-comps tbody');
    const saleRows = [];
    const sourceTable = Array.from(source.querySelectorAll('table')).find((table) => /sold|price/i.test(clean(table.querySelector('thead')?.textContent)));
    if (sourceTable) {
      const headers = Array.from(sourceTable.querySelectorAll('thead th')).map((node) => clean(node.textContent).toLowerCase());
      sourceTable.querySelectorAll('tbody tr').forEach((row) => {
        const cells = Array.from(row.querySelectorAll('td')).map((node) => clean(node.textContent));
        const priceIndex = headers.findIndex((label) => /price|sold/.test(label));
        const price = cells[priceIndex >= 0 ? priceIndex : cells.length - 1];
        if (!price || numberFrom(price) === null) return;
        const at = (pattern, fallback) => { const index = headers.findIndex((label) => pattern.test(label)); return cells[index >= 0 ? index : fallback] || '—'; };
        saleRows.push({ date: at(/date/, 0), platform: at(/platform|source|market/, 1), condition: at(/condition/, 2), price });
      });
    }
    if (!saleRows.length) source.querySelectorAll('.mm-sale').forEach((card) => {
      const price = clean(card.querySelector('strong')?.textContent);
      if (!price || numberFrom(price) === null) return;
      const parts = clean(card.querySelector('span')?.textContent).split(' · ');
      saleRows.push({ date: parts[0] || '—', platform: parts[1] || 'Verified sale', condition: parts[2] || '—', price });
    });
    if (saleRows.length && targetBody) {
      targetBody.replaceChildren();
      saleRows.slice(0, 4).forEach((sale, index) => {
        const row = document.createElement('tr');
        const labels = ['#', 'Date sold', 'Platform', 'Condition', 'Sold price'];
        [index + 1, sale.date, sale.platform, sale.condition, sale.price].forEach((value, cellIndex) => {
          const cell = document.createElement('td');
          cell.dataset.label = labels[cellIndex];
          cell.textContent = value;
          row.appendChild(cell);
        });
        targetBody.appendChild(row);
      });
    }
    const soldNumbers = saleRows.map((sale) => numberFrom(sale.price)).filter((value) => value !== null).sort((a, b) => a - b);
    const middle = soldNumbers.length ? soldNumbers.length % 2 ? soldNumbers[(soldNumbers.length - 1) / 2] : (soldNumbers[soldNumbers.length / 2 - 1] + soldNumbers[soldNumbers.length / 2]) / 2 : null;
    if (!prices.typical && middle !== null) prices.typical = money(middle);
    if (!prices.low && soldNumbers.length) prices.low = money(soldNumbers[0]);
    if (!prices.high && soldNumbers.length) prices.high = money(soldNumbers[soldNumbers.length - 1]);
    set('value-low', prices.low || '—');
    set('value-typical', prices.typical || 'Pending');
    set('value-high', prices.high || '—');
    set('median-price', middle !== null ? money(middle) : prices.typical || 'Pending');
    set('formula-value', prices.typical || 'Pending');
    if (prices.typical) set('explanation', `The estimated typical value is ${prices.typical}, based on the available completed sales for this exact release. The low and high values reflect the range of comparable sales.`);

    const rarityText = clean([report.dataset.mmveTitle, fact('release class'), fact('rarity'), fact('variation'), fact('special')].filter(Boolean).join(' ')).toLowerCase();
    const flags = {
      super: /super treasure hunt|\bsth\b/.test(rarityText),
      treasure: !/super treasure hunt/.test(rarityText) && /treasure hunt|\bth\b/.test(rarityText),
      exclusive: /exclusive/.test(rarityText),
      rlc: /\brlc\b|convention/.test(rarityText),
      variation: /variation|error/.test(rarityText),
      short: /short card|short pack|\bsp\b/.test(rarityText),
      special: /zamac|special/.test(rarityText)
    };
    Object.entries(flags).forEach(([key, value]) => {
      const node = report.querySelector(`[data-mmve-rarity="${key}"]`);
      if (node && value) node.textContent = 'Yes';
    });
    set('rarity-score', '—');
    set('rarity-signal', '—');
    set('rarity-label', 'Not rated');
    const rarityNote = report.querySelector('.mmve-rarity aside small');
    if (rarityNote) rarityNote.textContent = 'A release label alone does not establish rarity.';
    set('outlook-12', 'Not rated');
    set('outlook-5', 'Not rated');
    set('demand-label', 'Not rated');
    set('risk-label', 'Not rated');

    let typicalNumber = numberFrom(prices.typical);
    const renderCollection = (record) => {
      const packagingLabels = { loose: 'Loose', carded: 'Carded', boxed: 'Boxed', sealed_set: 'Sealed set', unknown: 'Not recorded' };
      const conditionLabels = { mint: 'Mint', near_mint: 'Near Mint', very_good: 'Very Good', good: 'Good', fair: 'Fair', poor: 'Poor', custom: 'Custom / modified', not_graded: 'Not graded' };
      if (!record) {
        set('packaging', 'Not recorded');
        set('condition', 'Not graded');
        set('condition-score', '—/100');
        set('purchase-price', 'Not entered');
        set('potential-gain', 'Pending');
        set('potential-roi', 'Pending');
      } else {
        const packaging = packagingLabels[record.packaging] || 'Not recorded';
        const condition = conditionLabels[record.condition] || 'Not graded';
        const conditionScores = { mint: 100, near_mint: 90, very_good: 80, good: 70, fair: 55, poor: 35, custom: 60 };
        set('packaging', packaging);
        set('condition', condition);
        set('condition-score', `${conditionScores[record.condition] || 0}/100`);
        set('card-condition', packaging === 'Carded' ? condition : 'Not applicable');
        set('blister-condition', packaging === 'Carded' ? condition : 'Not applicable');
        set('paint-condition', condition);
        set('wheel-condition', condition);
        set('condition-notes', record.notes || 'Saved collector condition; visual appraisal is not independently verified.');
        if (record.purchase_price !== null && record.purchase_price !== undefined) {
          const purchase = Number(record.purchase_price), currency = String(record.purchase_currency || '').toUpperCase(), basis = record.purchase_price_basis;
          if (!Number.isFinite(purchase) || purchase < 0) { set('purchase-price', 'Needs review'); set('potential-gain', 'Unavailable'); set('potential-roi', 'Unavailable'); }
          else if (!/^[A-Z]{3}$/.test(currency) || !['unit', 'lot'].includes(basis)) { set('purchase-price', 'Cost needs currency and basis review'); set('potential-gain', 'Unavailable'); set('potential-roi', 'Unavailable'); }
          else {
            let formattedPurchase = '';
            try { formattedPurchase = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(purchase); } catch (_) { /* Unsupported legacy currency stays out of comparison. */ }
            if (!formattedPurchase) { set('purchase-price', 'Cost currency needs review'); set('potential-gain', 'Unavailable'); set('potential-roi', 'Unavailable'); }
            else {
              set('purchase-price', formattedPurchase + ' per ' + basis);
              if (typicalNumber !== null && currency === 'USD' && basis === 'unit') { const gain = typicalNumber - purchase; set('potential-gain', (gain >= 0 ? '+' : '−') + money(Math.abs(gain))); set('potential-roi', purchase > 0 ? (gain >= 0 ? '+' : '') + ((gain / purchase) * 100).toFixed(1) + '%' : 'N/A'); }
              else { set('potential-gain', 'Unavailable for this currency or basis'); set('potential-roi', 'Unavailable for this currency or basis'); }
            }
          }
        } else {
          set('purchase-price', 'Not recorded'); set('potential-gain', 'Pending'); set('potential-roi', 'Pending');
        }
      }
      report.querySelectorAll('[data-mm-add]').forEach((button, index) => {
        button.textContent = record ? (index ? 'UPDATE MY COLLECTION' : '◉ Update This Casting') : (index ? 'SAVE TO MY COLLECTION' : '◉ Track This Casting');
      });
    };
    const handle = report.dataset.mmveHandle;
    renderCollection(readCollection()[handle] || null);
    window.addEventListener('mm:collection-record-saved', (event) => {
      if (!event.detail || event.detail.handle === handle) renderCollection(event.detail || readCollection()[handle] || null);
    });

    const status = (message) => {
      report.querySelector('[data-mmve-status]').textContent = message;
      const toolbarStatus = root.querySelector('[data-mm-tool-status]');
      if (toolbarStatus) toolbarStatus.textContent = message;
    };
    report.querySelectorAll('[data-mm-add]').forEach((button) => button.addEventListener('click', () => {
      const opener = root.querySelector('[data-mm-collection-open]');
      if (opener) opener.click();
      else location.href = '/pages/collector-portfolio';
    }));
    const copy = async (value) => {
      if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(value);
      const field = document.createElement('textarea');
      field.value = value;
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    };
    report.querySelectorAll('[data-mm-share]').forEach((button) => button.addEventListener('click', async () => {
      const url = report.dataset.mmveUrl || location.href;
      try {
        await copy(url);
        status('Report link copied.');
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          await navigator.share({ title: report.dataset.mmveTitle || document.title, text: 'Muncle Mikes collector report', url });
          status('Report shared.');
        }
      } catch (error) {
        if (error?.name !== 'AbortError') status('Sharing is unavailable in this browser.');
      }
    }));
    const qrValue = `${location.origin}${location.pathname}`;
    const qrReady = drawQr(report.querySelector('[data-mmve-qr]'), qrValue);
    if (!qrReady) {
      const link = report.querySelector('[data-mmve-verify-link]');
      if (link) link.textContent = 'OPEN';
    }

    report.dataset.mmveDataHost = 'shopify';
  };
  document.querySelectorAll('.mmcr-page').forEach((root) => {
    if (new URLSearchParams(location.search).get('mm_mobile_qa') === '1') root.classList.add('mmcr-mobile-qa');
initializeReport(root);
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-phase-seven-report-builder"] && !Shopify.designMode) return;
  try {
    
(()=>{'use strict';const root=document.getElementById('mm-p7-root');if(!root)return;const cloud=root.dataset.cloudUrl,key=root.dataset.cloudKey,guide=root.dataset.guideApi,report=root.dataset.reportApi,sessionKey='mm-collector-cloud-session';let session=null,memberToken=null,selected=null,generation=0;function storedToken(){try{return JSON.parse(localStorage.getItem(sessionKey)||'null')?.access_token||''}catch{return ''}}function owner(){return{token:session?.access_token||'',generation}}function current(o){return !!o.token&&o.generation===generation&&o.token===session?.access_token&&o.token===storedToken()}function assertOwner(o){if(!current(o))throw new Error('Your account changed. Reopen the report to continue.')}function paidAllowed(){return window.MMCollectorMembership?.isAllowed?.('values')===true}const $=s=>root.querySelector(s),clean=v=>String(v??'').replace(/[<>\u0000-\u001f]/g,'').trim();function toast(text,error=false){const n=$('[data-message]');n.textContent=text;n.hidden=!text;n.classList.toggle('is-error',error);if(text)setTimeout(()=>{if(n.textContent===text)n.hidden=true},6000)}async function request(path,options={}){const headers={apikey:key,'content-type':'application/json',...options.headers};if(session?.access_token)headers.Authorization=`Bearer ${session.access_token}`;const response=await fetch(cloud+path,{...options,headers}),body=await response.json().catch(()=>null);if(!response.ok)throw new Error(body?.message||body?.error||`Request failed (${response.status})`);return body}function store(value){generation++;memberToken=null;session=value;if(value)localStorage.setItem(sessionKey,JSON.stringify(value));else localStorage.removeItem(sessionKey)}async function restore(){const hash=new URLSearchParams(location.hash.slice(1));if(hash.get('access_token')){store({access_token:hash.get('access_token'),refresh_token:hash.get('refresh_token'),expires_at:Math.floor(Date.now()/1000)+Number(hash.get('expires_in')||3600)});history.replaceState({},'',location.pathname+location.search)}else{try{session=JSON.parse(localStorage.getItem(sessionKey)||'null')}catch{session=null}}if(session?.expires_at<Math.floor(Date.now()/1000)+60&&session.refresh_token){try{const refreshed=await request('/auth/v1/token?grant_type=refresh_token',{method:'POST',body:JSON.stringify({refresh_token:session.refresh_token})});refreshed.expires_at=Math.floor(Date.now()/1000)+Number(refreshed.expires_in||3600);store(refreshed)}catch{store(null)}}if(session){try{session.user=await request('/auth/v1/user');showMember();await membership()}catch{store(null);showGuest()}}else showGuest();const slug=new URLSearchParams(location.search).get('variation');if(slug)await loadVariation(slug)}function showGuest(){$('[data-auth-guest]').hidden=false;$('[data-auth-member]').hidden=true;$('[data-refresh-history]').hidden=true;memberToken=null;updateDownload()}function showMember(){$('[data-auth-guest]').hidden=true;$('[data-auth-member]').hidden=false;$('[data-member-email]').textContent=session.user?.email||'Collector Cloud connected';$('[data-refresh-history]').hidden=false;updateDownload()}async function login(event){event.preventDefault();const email=clean(new FormData(event.currentTarget).get('email')),redirect=`${location.origin}/pages/my-collector-workspace?view=casting-lookup-report${selected?`&variation=${encodeURIComponent(selected.slug)}`:''}`;toast('Sending secure sign-in link…');try{await request(`/auth/v1/otp?redirect_to=${encodeURIComponent(redirect)}`,{method:'POST',body:JSON.stringify({email,create_user:true,data:{workspace:'muncle-mikes-collector'}})});toast(`Check ${email} for your secure sign-in link.`)}catch(error){toast(error.message,true)}}async function signout(){try{await request('/auth/v1/logout',{method:'POST'})}catch{}store(null);showGuest();$('[data-report-history]').innerHTML='<p>Sign in to view your latest reports.</p>';toast('Signed out.')}async function membership(){const pinned=owner();try{if(!paidAllowed())throw new Error('Paid collector values and PDF reports are not available yet.');const response=await fetch(`${report}?action=collector-session`,{headers:{Authorization:`Bearer ${session.access_token}`}}),body=await response.json();assertOwner(pinned);if(!response.ok)throw new Error(body.error);memberToken=body.token;$('[data-member-status]').textContent='Active Value Engine membership · PDF reports unlocked';updateDownload();await historyList()}catch(error){if(!current(pinned))return;memberToken=null;$('[data-member-status]').textContent='Collector Cloud connected · active Value Engine membership required';updateDownload();toast(error.message==='active_value_engine_membership_required'?'An active Value Engine membership is required for PDF reports.':error.message,true)}}function updateDownload(){const button=$('[data-download]');button.disabled=!(selected&&memberToken&&paidAllowed());button.textContent=!selected?'Choose an exact variation first':!session?'Sign in to generate report':!memberToken?'Active membership required':'Download complete collector PDF'}async function search(event){event.preventDefault();const query=clean(new FormData(event.currentTarget).get('q')),box=$('[data-search-results]'),status=$('[data-search-status]');box.replaceChildren();status.textContent='Searching variations…';try{const response=await fetch(`${guide}?action=search&q=${encodeURIComponent(query)}&limit=50`),body=await response.json();if(!response.ok)throw new Error(body.error);const variations=body.variations||[];status.textContent=`${variations.length} exact variation result${variations.length===1?'':'s'}. Casting-family guesses are excluded.`;for(const item of variations){const row=document.createElement('article'),info=document.createElement('div'),title=document.createElement('strong'),meta=document.createElement('p'),button=document.createElement('button');row.className='mm-p7__result';title.textContent=item.variation_name||item.casting_name;meta.textContent=[item.release_year,item.casting_name,item.series,item.toy_number,item.body_color,item.wheel_type].filter(Boolean).join(' · ');button.type='button';button.textContent='Confirm variation';button.addEventListener('click',()=>loadVariation(item.slug));info.append(title,meta);row.append(info,button);box.append(row)}}catch(error){status.textContent=error.message}}async function loadVariation(slug){const status=$('[data-search-status]');status.textContent='Checking the selected variation…';try{const response=await fetch(`${guide}?action=variation&slug=${encodeURIComponent(slug)}`),body=await response.json();if(!response.ok||!body.variation?.id)throw new Error(body.error||'Exact variation not found');selected=body.variation;renderSelection();history.replaceState({},'',`${location.pathname}?view=casting-lookup-report&variation=${encodeURIComponent(selected.slug)}`);status.textContent='Exact variation confirmed.';updateDownload();$('[data-selection]').scrollIntoView({behavior:'smooth',block:'start'})}catch(error){toast(error.message,true)}}function renderSelection(){const v=selected,section=$('[data-selection]'),details=$('[data-selection-details]'),image=$('[data-selection-image]'),placeholder=$('[data-selection-placeholder]');section.hidden=false;$('[data-selection-title]').textContent=v.variation_name||v.casting_name;details.replaceChildren();[['Casting',v.casting_name],['Variation',v.variation_name],['Year',v.release_year],['Series',v.series],['Toy number',v.toy_number],['Collector number',v.collector_number],['Color',v.body_color],['Wheels',v.wheel_type],['Base',v.base_type],['Package',v.package_type]].forEach(([label,value])=>{const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value||'Not documented';details.append(dt,dd)});if(v.primary_image_url&&v.image_ready){image.src=v.primary_image_url;image.alt=`Research reference for ${v.variation_name||v.casting_name}`;image.hidden=false;placeholder.hidden=true}else{image.hidden=true;placeholder.hidden=false}const confidence=Number(v.confidence||0),grade=v.evidence_grade||'Pending',sales=Number(v.sales_count||0),value=v.value_typical==null?'Not enough sales to estimate a value yet':'An active membership is required for value estimates';$('[data-selection-evidence]').textContent=`${v.currency||'Currency not documented'} · ${v.calculated_at||v.last_valued_at?`As of ${v.calculated_at||v.last_valued_at}`:'Valuation date not documented'} · Historical evidence · ${value} · Confidence ${confidence||'pending'}${confidence?'%':''} · Evidence grade ${grade} · ${sales} supporting sale${sales===1?'':'s'}.` }async function download(){if(!selected||!memberToken||!paidAllowed())return;const pinned=owner(),pinnedToken=memberToken,pinnedSelection=selected;const status=$('[data-download-status]'),button=$('[data-download]');button.disabled=true;status.textContent='Preparing your collector report…';try{let response=await fetch(`${report}?action=pdf&type=variation&slug=${encodeURIComponent(selected.slug)}`,{headers:{Authorization:`Bearer ${memberToken}`}});assertOwner(pinned);if(response.status===403){await membership();response=await fetch(`${report}?action=pdf&type=variation&slug=${encodeURIComponent(selected.slug)}`,{headers:{Authorization:`Bearer ${memberToken}`}})}if(!response.ok){const body=await response.json().catch(()=>({}));throw new Error(body.error||`PDF failed (${response.status})`)}const blob=await response.blob();assertOwner(pinned);if(memberToken!==pinnedToken||selected!==pinnedSelection||!paidAllowed())throw new Error('The selected report changed. Try again.');const url=URL.createObjectURL(blob),link=document.createElement('a'),reportId=response.headers.get('x-mm-report-id');link.href=url;link.download=`muncle-mikes-${selected.slug}-collector-report.pdf`;link.click();setTimeout(()=>URL.revokeObjectURL(url),1500);status.textContent=`Report ${reportId||''} generated and downloaded.`;toast('Collector report downloaded.');await historyList()}catch(error){if(current(pinned)){status.textContent=error.message;toast(error.message,true)}}finally{updateDownload()}}async function historyList(){if(!memberToken||!paidAllowed())return;const pinned=owner();const box=$('[data-report-history]');try{const response=await fetch(`${report}?action=reports`,{headers:{Authorization:`Bearer ${memberToken}`}}),body=await response.json();assertOwner(pinned);if(!paidAllowed())return;if(!response.ok)throw new Error(body.error);const reports=body.reports||[];box.replaceChildren();if(!reports.length){const p=document.createElement('p');p.textContent='No reports generated yet.';box.append(p);return}for(const item of reports){const row=document.createElement('div'),title=document.createElement('strong'),meta=document.createElement('span');row.className='mm-p7__history';title.textContent=item.data_snapshot?.variation_name||item.data_snapshot?.casting_name||item.entity_slug;meta.textContent=`${item.report_id} · ${String(item.generated_at).slice(0,10)} · ${item.page_count||'—'} pages · Confidence ${item.confidence??'pending'}`;row.append(title,meta);box.append(row)}}catch(error){if(current(pinned))box.textContent=error.message}}window.addEventListener('storage',event=>{if((!event.key||event.key===sessionKey)&&session?.access_token!==storedToken()){generation++;memberToken=null;session=null;showGuest();$('[data-report-history]').replaceChildren();$('[data-download-status]').textContent=''}});window.addEventListener('mm:membership-change',()=>{if(!paidAllowed()){generation++;memberToken=null;showGuest();$('[data-report-history]').replaceChildren()}});$('[data-search-form]').addEventListener('submit',search);$('[data-login]').addEventListener('submit',login);$('[data-signout]').addEventListener('click',signout);$('[data-download]').addEventListener('click',download);$('[data-refresh-history]').addEventListener('click',historyList);restore()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-related-products')) {
  customElements.define('mm-related-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      const load = async () => {
        this.observer?.disconnect();
        try {
          const response = await fetch(this.dataset.url, {
            credentials: 'same-origin',
            signal: AbortSignal.timeout(8000)
          });
          if (!response.ok || !this.isConnected) return;

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = documentFragment.querySelector('[data-mm-related-items]');
          const current = this.querySelector('[data-mm-related-items]');
          if (!incoming || !current || this.matches(':focus-within')) return;

          const incomingCards = incoming.querySelectorAll('[data-mm-related-product]').length;
          const currentCards = current.querySelectorAll('[data-mm-related-product]').length;

          // Never replace a populated server-side shelf with a weaker/empty async result.
          if (incomingCards > currentCards) current.replaceChildren(...incoming.children);
        } catch (_) {
          // Server-rendered fallback remains visible when the recommendations endpoint fails.
        }
      };

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => { if (entries.some(entry => entry.isIntersecting)) load(); },
          {rootMargin:'300px'}
        );
        this.observer.observe(this);
      } else {
        load();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-r32-product"]) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  function init(scope = document) {
    const roots = [...(scope.matches?.('.r32-product[data-mm-product-root]') ? [scope] : []), ...scope.querySelectorAll?.('.r32-product[data-mm-product-root]') || []];
    roots.forEach(root => {
      if (initialized.has(root)) return;
      const form = root.querySelector('.mm-product-form');
      const bar = root.querySelector('[data-r32-sticky-buy]');
      const action = root.querySelector('[data-r32-sticky-action]');
      const returnButton = root.querySelector('[data-r32-return-buy]');
      if (!form || !bar || !action) return;
      initialized.add(root);
      const mobile = matchMedia('(max-width: 600px)');
      let formVisible = true;
      const render = () => { bar.hidden = !mobile.matches || formVisible; };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { formVisible = Boolean(entries[0]?.isIntersecting); render(); }, {threshold: 0.18});
        observer.observe(form);
      }
      if (returnButton) {
        returnButton.addEventListener('click', () => {
          form.scrollIntoView({behavior: 'smooth', block: 'center'});
          setTimeout(() => form.querySelector('select:not(:disabled), input[name="quantity"], button[type="submit"]')?.focus({preventScroll:true}), 350);
        });
      }
      mobile.addEventListener?.('change', render);
      render();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
